import React, { FC } from "react"
import { IReplenishmentDto } from "../../../../../types/replenishment/IReplenishmentDto"
import { download, getFormattedDate, spacedNum } from "../../../../common/CommonHelper"
import { IMG } from "../../../../common/CONST"
import { useStore } from "../../../../../stores/RootStoreContext"
import * as TrinityAPI from "../../../../../requests/TrinityAPI"

export const CRDone: FC<{ replenishment: IReplenishmentDto }> = ({ replenishment }) => {
  const { userStore } = useStore()

  const rollback = () => {
    if (!replenishment.id) return

    TrinityAPI.rollbackStatus(replenishment.id, response => {
      if (response.status === 200) {
        window.location.reload()
      }
    })
  }

  if (replenishment.status === "DONE") {
    return (
      <>
        <ul className="form-full">
          <li className="form-block-popup width-4-blocks">
            <h4 className="heading-chapter">Инвойс</h4>
            <div className="flex-row-10">
              <fieldset>
                <legend>Номер и дата</legend>
                <p className="text-form">
                  {replenishment.invoiceNumber} от {getFormattedDate(replenishment.invoiceDate || "")}
                </p>
              </fieldset>
            </div>
            <div className="flex-row-10">
              <fieldset>
                <legend>Сумма</legend>
                <p className="text-form">
                  {spacedNum(replenishment.invoiceAmount ? Number(replenishment.invoiceAmount) / 100 : "")}{" "}
                  {replenishment.invoiceCurrency}
                </p>
              </fieldset>
            </div>
            <fieldset className="fieldset-fit">
              <legend></legend>
              <button
                className="btn download-btn"
                onClick={() => download(replenishment.id?.toString(), "CLIENT_INVOICE")}
              >
                <img src={IMG.download} alt="" />
                Скачать
              </button>
            </fieldset>
          </li>
          <li className="form-block-popup width-4-blocks">
            <h4 className="heading-chapter">Контракт с заводом</h4>

            <fieldset>
              <legend>Дата</legend>
              <p className="text-form">{getFormattedDate(replenishment.contractDate || "")}</p>
            </fieldset>
            <fieldset>
              <legend>Номер</legend>
              <p className="text-form">№{replenishment.contractNumber}</p>
            </fieldset>
            <fieldset className="fieldset-fit">
              <legend></legend>
              <button
                className="btn download-btn"
                onClick={() => download(replenishment.id?.toString(), "CLIENT_CONTRACT")}
              >
                <img src={IMG.download} alt="" />
                Скачать
              </button>
            </fieldset>
          </li>
          <li className="form-block-popup width-4-blocks">
            <h4 className="heading-chapter">Доп. соглашение</h4>
            <fieldset>
              <legend>Дата</legend>
              <p className="text-form">{getFormattedDate(replenishment.additionalAgreementDate || "")}</p>
            </fieldset>
            <fieldset>
              <legend>Номер</legend>
              <p className="text-form">№{replenishment.additionalAgreementNumber}</p>
            </fieldset>
            <div className="flex-row-10">
              <button
                className="btn download-btn"
                onClick={() => download(replenishment.id?.toString(), "CLIENT_AGREEMENT")}
              >
                <img src={IMG.download} alt="" />
                Скачать
              </button>
            </div>
          </li>
          <li className="form-block-popup width-4-blocks">
            <h4 className="heading-chapter">Платежные поручения</h4>
            {replenishment.paymentOrderFiles && replenishment.paymentOrderFiles?.length > 0 ? (
              replenishment.paymentOrderFiles.map((f, index) => (
                <fieldset className="fieldset-fit">
                  <legend></legend>
                  <button className="btn download-btn" key={index} onClick={() => download(f.id, "PAYMENT_ORDER")}>
                    <img src={IMG.download} alt="" />
                    {`Платежное поручение №${index + 1}`}
                  </button>
                </fieldset>
              ))
            ) : (
              <></>
            )}
            <div className="flex-row-10">
              <button className="btn black-btn" onClick={() => window.open(`/replenishment/${replenishment.id}/bill`)}>
                Открыть счет
              </button>
            </div>
          </li>
        </ul>
        {userStore.isAdmin ? (
          <div className="flex-row-10">
            <button className="btn" onClick={rollback}>
              {"Откатить на предыдущий статус"}
            </button>
          </div>
        ) : (
          <></>
        )}
      </>
    )
  } else {
    return <></>
  }
}
